/**
 * detection-odors-view.js
 */

import React from 'react';
import { Typography, Button, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Types } from 'utils/constants';
import { displayNumber } from 'utils/misc';
import InfoRow from 'components/info-row';


const useStyles = makeStyles(theme => ({
  envsOdorsContainer: {
    '& > div': {
      marginBottom: theme.spacing(4),
      '&:last-child': {
        marginBottom: theme.spacing(2),
      },
    },
  },
  envOdorsSection: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.sys.surfaceContainerHigh,
    borderRadius: '5px',
  },
  odorIndent: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1.5),
    },
  },
  iconIndent: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(-1),
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  photoContainer: {
    marginTop: theme.spacing(1),
    padding: 2,
    maxWidth: 100,
    '& a': {
      lineHeight: 0,
      '& img': {
        width: '100%',
        height: 'auto'
      }
    }
  }
}));

export default function DetectionOdorsView(props) {
  const { 
    environments, 
    recordType,
  } = props;
  const classes = useStyles();
  const itemName = recordType === Types.Record.EXERCISE ? 'odor' : 'seizure';

  return (
    <>
      {/* no environments */}
      {(!environments || environments.length === 0) &&
      <Typography variant='body2'>
        No environments or odors configured
      </Typography>}


      <div className={classes.envsOdorsContainer}>
        {environments && environments.map(env =>
          <div id="test" key={env.type.id}>

            {/* environment title */}
            <Typography variant="subtitle2">
              {`Sniff of ${env.count} ${env.type.name}${(env.count === 1 || env.type.name === 'Luggage') ? '' : 's'}
              ${recordType === Types.Record.EXERCISE ? `where ${env.odorEnvironments.length} had odors`
              : `with ${env.odorEnvironments.length} indication${env.odorEnvironments.length === 1 ? '' : 's'}`}`}
            </Typography>

            {env.odorEnvironments.map(odorEnv =>
              <div key={odorEnv.id} className={classes.envOdorsSection}>

                {/* odor-env & description */}
                <InfoRow
                  title={odorEnv.name}
                  text={odorEnv.description}
                  iconName="odor-environment"
                />

                {/* vehicle info */}
                {/* we don't display for deployments because name and description already have this info */}
                {odorEnv.vehicle && recordType !== Types.Record.DEPLOYMENT &&
                <Typography variant="body2" className={classes.iconIndent}>
                  {`${odorEnv.vehicle.color} ${odorEnv.vehicle.make} ${odorEnv.vehicle.model} (${odorEnv.vehicle.type.name})`}
                </Typography>}

                {/* odors */}
                <div className={classes.odorIndent}>
                  {odorEnv.odors.length === 0
                    ? `No ${itemName.toCamelCase()}s`
                    : ''}
                  {odorEnv.odors.map(odor =>
                    <div key={odor.id} style={{ marginTop: 8 }}>

                      {/* odor title */}
                      <InfoRow
                        title={`${odor.type.name} ${itemName}`}
                        text={(odor.type.id === Types.OdorPrimary.PROOFING
                          ? `${odor.packaging?.name || ''}, `
                          : odor.subType?.name ? `${odor.subType?.name}, ` : '')
                        + (`${displayNumber(odor.quantity)} ${odor.quantityUnit?.name || ''}`)}
                        iconName="odor"
                      />

                      {/* odor details */}
                      <Typography variant="body2" className={classes.iconIndent}>
                        Concealed: {odor.concealedLocation}
                        {odor.height && odor.depth && (<><br/>Height: {odor.height}, Depth: {odor.depth}</>)}
                        {odor.packaging?.name && odor.type.id !== Types.OdorPrimary.PROOFING && (<><br />Packaging: {odor.packaging.name}</>)}

                        {/* deployment extra packaging */}
                        {odor.packaging2?.name && (<><br />Packaging 2: {odor.packaging2.name}</>)}
                        {odor.packaging3?.name && (<><br />Packaging 3: {odor.packaging3.name}</>)}
                        {odor.packaging4?.name && (<><br />Packaging 4: {odor.packaging4.name}</>)}

                        {odor.description && (<><br />Description: {odor.description}</>)}
                      </Typography>

                      {/* odor photo */}
                      {odor.photo &&
                      <div className={classes.iconIndent} style={{ marginTop: 0 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          disableElevation
                          className={classes.photoContainer}
                        >
                          <Link
                            href={odor.photo.url}
                            target="_blank"
                          >
                            <img src={odor.photo.url} alt={odor.photo.id} />
                          </Link>
                        </Button>
                      </div>}

                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}